import styled from 'styled-components';
import { CHAT_WIDTH, colors, fontFamily } from '../Utils/tokens';

export const ChatContainer = styled.div`
  display: flex;
  flex: 1 0 0;
  flex-direction: column;
  min-height: 0;
  font-family: ${fontFamily};
`;

export const ScrollArea = styled.div`
  position: relative;
  display: flex;
  flex: 1 0 0;
  flex-direction: column;
  min-height: 0;
`;

export const Scroller = styled.div`
  display: flex;
  flex: 1 0 0;
  flex-direction: column;
  min-height: 0;
  overflow-y: auto;
`;

/** "Chat AI / Chat": conteúdo alinhado ao fim e centralizado em 512px (tela cheia). */
export const ChatColumn = styled.div`
  display: flex;
  flex: 1 0 auto;
  flex-direction: column;
  justify-content: flex-end;
  width: 100%;
  max-width: ${CHAT_WIDTH}px;
  margin: 0 auto;
  padding: 16px;
`;

export const ChatGradient = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  height: 24px;
  background: linear-gradient(to top, ${colors.surface}, rgba(255, 255, 255, 0));
  pointer-events: none;
`;

/** "Chat AI / Chat / Input" */
export const InputSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
  gap: 6px;
  width: 100%;
  max-width: ${CHAT_WIDTH}px;
  margin: 0 auto;
  padding: 6px 16px 12px;
  background-color: ${colors.surface};
`;

export const Disclaimer = styled.p`
  width: 100%;
  margin: 0;
  font-size: 10px;
  font-weight: 400;
  line-height: 16px;
  color: ${colors.onSurfacePlaceholder};
  text-align: center;
`;
